import { PartDetails } from "../../../../explorer/types/SpareParts/PartDetails";
import ServiceProvider from "../../../configuration/ServiceProvider";
import { useAppError } from "../../../hook/useAppError";
import { usePartDetails } from "../../../hook/usePartDetails";
import { DrawerWithoutBackground } from "./DrawerPartDetails.styles";
import useLanguages from "../../../../explorer/hooks/useLanguages";
import DrawerHeader from "./DrawerPartDetailsHeader";
import { FC, PropsWithChildren, useEffect, useState } from "react";
import { Box } from "@mui/material";
import DrawerSkeleton from "../PartDetailsSkeleton";
import PartDetailsInfo from "../PartDetails/PartDetailsInfo";
import PartDetailsTabs from "../PartDetails/PartDetailsTabs";

const DrawerPartDetails: FC<PropsWithChildren> = (props: PropsWithChildren) => {
    const [partDetails, setPartDetails] = useState<PartDetails>();
    const { partDetailsProps, closePartDetails } = usePartDetails();
    const [loading, setLoading] = useState<boolean>(true);

    const manufacturer = partDetailsProps.manufacturer;
    const partCode = partDetailsProps.partCode;
    const isReplaced = partDetailsProps.replacementCode ? true : false;
    const replacementCode = partDetailsProps.replacementCode;
    
    const code = isReplaced ? replacementCode! : partCode;
    const replacedCode = isReplaced ? partCode! : undefined;

    const [_, setAppError] = useAppError();
    const { currentLanguage } = useLanguages();

    useEffect(() => {
        if (partCode && manufacturer) {
            setLoading(true);

            ServiceProvider.SpareParts.getPartDetails(
                manufacturer,
                // Se c'è un replacementCode, il replacementCode diventa il partCode originale, altrimenti rimane lo stesso.
                code!,
                currentLanguage!
            )
                .then((result) => {
                    // Se c'è un replacementCode, il partCode originale e il replacementCode si invertono di posizione
                    // isReplaced ? result.lastReplacementPartCodes = partCode! : result.lastReplacementPartCodes = "";
                    setPartDetails(result);
                })
                .catch((error) => {setAppError(error);
                    setPartDetails({code: code} as PartDetails);
                    setLoading(false);
                    console.log(error);
                }).finally(() => setLoading(false));
        }
    }, [partDetailsProps.open]);

    return (
        <DrawerWithoutBackground
            anchor="right"
            open={partDetailsProps.open}
            onClose={() => closePartDetails()}
        >
            {!loading ? (
                <Box sx={{ overflow: "hidden", height: '100%', }}>
                    <DrawerHeader {...{...partDetails as PartDetails, replacedCode}} />
                    <PartDetailsInfo {...{...partDetails as PartDetails, replacedCode}} />
                    <PartDetailsTabs {...{...partDetails as PartDetails, replacedCode}} />
                </Box>
            ) : (
                <DrawerSkeleton />
            )}
        </DrawerWithoutBackground>
    );
};

export default DrawerPartDetails;
